<template>
    <div class="ecnu-signin">
        <!-- header -->
        <page-header ecnu></page-header>
        <div class="ecnu-sign-body " style="background-color: white;background-image: url('/assets/ecnu/images/ecnu-bg-01.jpg'); background-size:cover"> <!-- body -->
            <div class="page-container" style="height: 380px;margin-bottom: 40px;padding: 5px;">
                <el-row :gutter="10">
                    <el-col :lg="14" :md="14" class="text-center">
                        <img src="../assets/images/sign-in-pic.png" style="max-height: 100%; max-width: 100%">
                    </el-col>
                    <el-col :lg="10" :md="10">
                        <form class="clearfix" @submit.prevent="submitForm"
                              action="/">
                            <div style="padding: 20px;">
                                <h2 class="text-center" style="color: #666">用 户 登 录</h2>
                                <div class="line mt-4 mb-4" style="border-bottom-color: #999;"></div>
                                <div id="iptUsername">
                                    <div class="login-group">
                                        <input v-model="login.id" type="text" autocomplete="off"
                                               placeholder="学号/工号" class="input" value="" required>
                                        <div class="wrapper"><i class="fa fa-user"></i> &nbsp;</div>
                                    </div>
                                </div>
                                <div class="spacer"></div>
                                <div>
                                    <div class="login-group">
                                        <input v-model="login.password" type="password"
                                               autocomplete="off"
                                               placeholder="密码" class="input" value="" required>
                                        <div class="wrapper"><i class="fa fa-lock"></i> &nbsp;</div>
                                    </div>
                                </div>
                                <div class="spacer"></div>
                                <div id="" class="">
                                    <button type="submit" class="login-btn btn btn-block "
                                            style="font-size:20px;">登 录
                                    </button>
                                </div>
                                <div class="text-center mt-4">
                                    <a href="javascript:void(0);" @click="jumpToWechatCorp" style="color: darkcyan">
                                        <span><i class="fa fa-qrcode"></i> 企业扫码登录，请点击此处</span>
                                    </a>
                                </div>
                            </div>
                        </form>
                    </el-col>
                </el-row>
            </div>
            <div class="clearfix"></div>
        </div>

        <div class="footer" style="background-color: #f7f7f7;">
                    <div class="logo-address text-center">
                        <p>
                            <a href="http://www.eoffice.ecnu.edu.cn" target="_blank">技术支持：华东师范大学 信息化办公室</a>
                        | 联系电话：62233081 邮箱：its@ecnu.edu.cn | 沪ICP备05003394 <br />
                        支持的浏览器有：IE版本9以上，Chrome,Safari,Firefox，国内浏览器请使用极速模式。
                        </p>
                    </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import PageHeader from "../components/page-header"
    import qywxCommon from "../common/mixins/qywxCommon"

    export default {
        name: "sign-in-ecnu",
        components: {PageHeader},
        mixins:[qywxCommon],
        data() {
            return {
                login: {
                    id: '',
                    password: ''
                },
                ready: false
            }
        },
        computed: {
            ...mapState(['user', 'process']),
        },
        mounted() {
            this.qywxWebLogHandler();
        },
        methods: {
            ...mapMutations('user', ['setUserInfo']),
            submitForm() {
                const vm = this;
                if (!vm.login.id) {
                    vm.$message.error('必须要输入学号/工号。');
                } else {
                    vm.$api('SSO', vm.login, true).then(response => {
                        if (response.data.success) {
                            vm.setUserInfo(response.data.data);
                            vm.$router.replace("/");
                        }
                    });
                }
            },
            jumpToWechatCorp() {
                window.location.href = this.$organization.wx_redirect;
            },
            jumpToSignIn() {
                this.$router.push('/sign-in');
                this.show_login_error = false;
                this.ready = true;
            }
        },
    }
</script>

<style scoped lang="scss">
    $default-color : #c93e0c;

    .ecnu-signin {
        background-color: #f7f7f7;
        .header {
            min-height: 120px;
            background-color: white;
        }

        .header img {
            vertical-align: middle;
        }

        .logo {
            height: 120px;
            display: table-cell;
            vertical-align: middle;
        }

        .time {
            height: 120px;
            font-size: 26px;
            color: #E65100;
            line-height: 78px;
            text-align: right;
            padding-right: 5px;
            display: none;
        }

        .text-time {
            color: #E65100;
            font-weight: bold;
        }

        .ecnu-sign-body {
            display: flex;
            justify-content: center;
            align-content: center;
            align-items: center;
            height: calc(100vh - 200px);
            min-height: 500px;
        }
        .show_help {
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            z-index: 999
        }

        .show_help_content .title {
            font-size: 28px;
            text-align: left;
            margin-bottom: 5px;
        }

        .show_help_content .body {
            font-size: 16px;
            text-align: left;
        }

        .slide {
            width: 100%;
            height: 477px;
            background-size: cover;
            background-position: center;
        }

        .login {
            position: absolute;
            top: 0;
            width: 100%;
        }

        .login-wrap {
            width: 453px;
            height: 466px;
            position: relative;
            margin-top: 91px;
            float: right;
            margin-right: 62px;
        }

        .login-wrap-bg {
            height: 676px
        }

        .login-bg {
            width: 100%;
            height: 404px;
            position: absolute;
        }

        .login-table {
            margin-top: 30px;
            width: 330px;
            height: 220px;
            margin-left: 57px;
            border-spacing: 0;
        }

        .login-group {
            height: 40px;
            position: relative;
        }

        .login-group .input {
            height: 42px;
            box-sizing: border-box;
            border-radius: 3px;
            border: 1px solid #aaa;
            color: black;
            font-size: 14px;
            width: 100%;
            padding-left: 34px;
            transition: all 0.2s ease-in;
        }

        input::-webkit-input-placeholder {
            color: #999;
        }

        input::-moz-placeholder { /* Mozilla Firefox 19+ */
            color: #999;
        }

        input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
            color: #999;
        }

        input:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #e2e2e2;
        }

        input.input:focus {
            border-color: #65a883;
            outline: none;
            box-shadow: none;
        }

        input.input:hover {
            border-color: #65a883;
            outline: none;
            box-shadow: none;
        }

        .login-group .wrapper {
            color: #e2e2e2;
            text-align: center;
            width: 24px;
            line-height: 40px;
            position: absolute;
            top: 1px;
            left: 8px;
            transition: all 0.2s ease-in;
        }

        .login-group:hover .wrapper {
            color: #65a883;
        }

        .login-table a {
            color: #919191;
            font-size: 12px;
            text-decoration: none;
            transition: all 0.2s ease-in;
        }

        .login-table a:hover {
            color: #aaaa;
            text-decoration: none;
        }

        .spacer {
            height: 30px;
        }

        .login-btn {
            background-color: #5da47d;
            color: white;
            transition: all 0.2s ease-in;
        }

        .login-btn:hover {
            background-color: darken(#5da47d,10%);
            color: white;
        }

        .hint {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            padding-left: 57px;
            padding-right: 57px;
        }

        .hint a {
            font-size: 16px;
            color: #e0e0e0;
            transition: all 0.2s ease-in;
        }

        .hint a:hover {
            font-size: 16px;
            color: #fff;
            text-decoration: none;
        }

        .footer {
            min-height: 180px;
            background-color: white;
            color: #333;
            padding-top: 20px;
        }

        .footer .picture {
            margin-top: 30px;
            text-align: right;
            margin-right: 33px;
        }

        .footer .picture img {
            max-width: 100%;
        }

        .footer p {
            line-height: 20px;
            font-size: 13px;
            color: #666;
            padding: 0;
            margin: 0;
        }


        @media (max-width: 767.98px) {
            .login-wrap {
                width: 100%;
                height: 466px;
                position: relative;
                margin: 91px auto 0;
                float: none;
            }

            .login-table {
                width: auto;
                margin-right: 20px;
                margin-left: 20px;
            }

            .footer {
                text-align: center;
            }
            .footer .picture {
                text-align: center;
            }
        }
    }

</style>
